// Pendiente de revisar
import i18n from "@/i18n/i18n";
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class ConsolidationDto extends ItiBaseDto {
	public type: string;
	public value: number;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}

	public get typeTranslation() {
		return this.type === "SIZE"
			? i18n.t("automation.consolidation.type.size")
			: i18n.t("automation.consolidation.type.time");
	}

	// Convertir el valor a horas o MB para mostrar en el formulario
	public get displayValue(): number {
		const conversionFactors: { [key: string]: number } = {
			TIME: 1 / 3600, // Convertir segundos a horas
			SIZE: 1 / (1000 * 1000), // Convertir bytes a MB (sistema binario)
		};

		return this.value * (conversionFactors[this.type] || 1);
	}

	// Setter para establecer el valor en segundos o bytes desde el formulario
	public set displayValue(displayValue: number) {
		const conversionFactors: { [key: string]: number } = {
			TIME: 3600, // Convertir horas a segundos
			SIZE: 1000 * 1000, // Convertir MB a bytes (sistema binario)
		};

		this.value = displayValue * (conversionFactors[this.type] || 1);
	}
}
